import fetchJsonp from 'fetch-jsonp'
import Component from '../../lib/component'
import { RootComponent } from '../../main'

export default class MailchimpFormComponent extends Component {
    static selector () {
        return '.mailchimp-form'
    }

    constructor (opts) {
        super(opts)

        if (!this.el
                || !this.getForm())
            return

        window.fetchJsonp = fetchJsonp

        this.addFeatureTest({
            csspointerevents: () => this.detectCSSProp('pointer-events')
        })

        this.addFeaturesToClassName()

        this.render()
        this.listen()
        this.onScroll()
    }

    listen () {
        this.getForm().onvalid = (e) =>
            this.onFormValid(e)

        this.getForm().oninvalid = (e) =>
            this.onFormInvalid(e)

        this.getInputsPattern()
            .forEach((input) => {
                input.oninvalid = (e) => {
                    e.preventDefault()
                    e.stopPropagation()

                    this.onForceDirty()
                }

                input.onfocus = (e) =>
                    this.onFormReset()

                input.onblur = (e) =>
                    this.onDirty(e)

                input.onkeyup = () =>
                    this.getForm().classList.contains('dirty')
                        ? this.onDirty()
                        : null
            })

        this.getSubmitButton().onfocus = (e) =>
            this.onDirty()

        this.getSubmitButton().onclick = () =>
            this.onForceDirty()

        this.getForm().onsubmit = (e) =>
            this.onSubmit(e)

        this.getSliderToggleButtons()
            .forEach(el => el.addEventListener('click',
                this.onSliderToggleButtonClick.bind(this)))

        document.addEventListener('keydown', e =>
            this.isSliderCardExpanded()
                    && (e.key || e.keyIdentifier || '')
                        .match(/escape/i)
                ? this.onSliderToggleButtonClick()
                : null)

        document.addEventListener('focusin',
            this.onDocumentFocus.bind(this))

        document.addEventListener('focusout',
            this.onDocumentFocus.bind(this))

        if (RootComponent.Scroller)
            RootComponent.Scroller.state
                .on('update', this.onScroll.bind(this))
    }

    onDocumentFocus (e) {
        if (this.el.contains(document.activeElement)
                || !this.el.querySelector('.invalid')
                || (e.type === 'focusout'
                    && e.relatedTarget
                    && this.el.contains(e.relatedTarget)))
            return

        const inputs = this.getInputs()
            .filter(el => el.type !== 'hidden')

        const inputsEmpty = inputs
            .filter(el => !el.value)

        if (inputs.length !== inputsEmpty.length)
            return

        this.onFormReset(true)
    }

    onFormValid (e) {
        if (this.getForm().classList.contains('invalid'))
            this.getForm().classList.remove('invalid')
    }

    onFormInvalid (e) {
        e.preventDefault()
        e.stopPropagation()

        if (this.getBrowser('name').match(/(ie|edge)/))
            this.getForm().classList.add('invalid')
    }

    onForceDirty () {
        this.getInputsPattern()
            .forEach(input => input.classList.add('dirty'))

        this.onDirty()
    }

    onDirty (e) {
        this.getForm().classList.add('dirty')

        if (!this.isFormValid()
                && this.getBrowser('name').match(/(ie|edge)/))
            this.getForm().classList.add('invalid')

        if (e && e.target)
            e.target.classList.add('dirty')

        this.getInputsPattern()
            .forEach(input => {
                input.classList[input.validity.valid ? 'remove' : 'add'](
                    'invalid')
            })
    }

    onFormReset (force) {
        if (!force
                && !(this.getForm().classList.contains('success')
                    || this.getForm().classList.contains('error')))
            return

        this.getForm().classList.remove('dirty')
        this.getForm().classList.remove('invalid')
        this.getForm().classList.remove('success')
        this.getForm().classList.remove('error')

        this.getInputs()
            .filter(el => el.type !== 'hidden')
            .forEach(el => {
                if (el.checked)
                    el.checked = false

                if (el.value)
                    el.value = ''

                if (el.classList.contains('dirty'))
                    el.classList.remove('dirty')

                if (el.classList.contains('invalid'))
                    el.classList.remove('invalid')
            })
    }

    onSubmit (e) {
        e.preventDefault()
        e.stopPropagation()

        if (this.getForm().classList.contains('success'))
            return

        const isValid = this.isFormValid()

        if (isValid && this.getForm().classList.contains('invalid'))
            this.getForm().classList.remove('invalid')

        if (!isValid && this.getBrowser('name').match(/(ie|edge)/))
            this.els.mailchimpForm.classList.add('invalid')

        if (!isValid)
            return this.onForceDirty()

        if (this.getForm().classList.contains('submitting'))
            return

        this.getForm().classList
            .add('submitting')

        // Update form state
        this.onDirty()

        const epoch = new Date().getTime()

        const queryString = [...new window.FormData(this.getForm()).entries()]
            .map(entry => entry.map(encodeURIComponent).join('='))
            .join('&')

        const url = `${this.getForm().getAttribute('action')}/form-post-json?${
            queryString}&_=${epoch}&c=jsonp_cb_${epoch}`

        window
            .fetchJsonp(url, {
                jsonpCallbackFunction: `jsonp_cb_${epoch}`
            })
            .then(res => res.json())
            .then(json => ({
                msg: (json.msg || 'An unknown error has occurred'),
                result: json.result || 'error'
            }))
            .then(json => {
                const alertsEl = this.getForm()
                    .querySelector('.mailchimp-form-res-alerts')

                if (alertsEl)
                    alertsEl.focus()

                const responseTextEl = alertsEl
                    ? alertsEl.querySelector(`.${json.result} .msg`)
                    : null

                if (responseTextEl) {
                    responseTextEl.innerHTML = json.msg

                    Array.from(responseTextEl.querySelectorAll('a'))
                        .forEach((el) => {
                            el.target = '_blank'
                            el.title = 'Opens in New Tab'
                            el.rel = 'noopener noreferrer'
                        })
                }

                this.getForm().classList
                    .remove('submitting')

                this.getForm().classList
                    .add(json.result)
            })
    }

    onScroll () {
        if (window.innerWidth < 768
                || !this.getSliderCard()
                || this.getSliderCard().getAttribute('data-expanded'))
            return

        const scrollY = RootComponent.Scroller.state.get('scrollY')

        if (scrollY >= window.innerHeight * 0.4)
            this.onSliderToggleButtonClick()
    }

    onSliderToggleButtonClick (e) {
        const card = this.getSliderCard()

        if (!card)
            return

        const isExpand = card.getAttribute('data-expanded') !== 'true'

        card.setAttribute('data-expanded', isExpand)

        this.getSliderToggleButtons()
            .forEach(el => el.setAttribute('aria-expanded', isExpand))

        const isFocus = e && isExpand

        let focusEl = null

        if (isFocus
                && card.getAttribute('aria-labelledby'))
            focusEl = card.querySelector(`#${
                card.getAttribute('aria-labelledby')}`)

        if (isFocus
                && !focusEl)
            focusEl = this.getInputs()
                .filter(input => input.type !== 'hidden')[0]

        if (focusEl)
            focusEl.focus()

        if (!isExpand
                && (document.activeElement === this.el
                    || this.el.contains(document.activeElement)))
            document.activeElement.blur()
    }

    getForm () {
        return this.el.querySelector('form')
    }

    getInputs () {
        return Array.from(this.el.querySelectorAll('input'))
    }

    getInputsPattern () {
        return Array.from(this.el.querySelectorAll('input[pattern]'))
    }

    getInputsRequired () {
        return Array.from(this.el.querySelectorAll('input[required]'))
    }

    getSubmitButton () {
        return this.el.querySelector('[type="submit"]')
    }

    getSliderCard () {
        return this.el.querySelector('.mailchimp-form-slider-card')
    }

    getSliderToggleButtons () {
        return Array.from(this.el.querySelectorAll('.mailchimp-form-slider-toggle'))
    }

    isSliderCardExpanded () {
        return this.getSliderCard()
            && this.getSliderCard().getAttribute('data-expanded') === 'true'
    }

    isFormValid () {
        let isValid = true

        this.getInputsPattern()
            .forEach(input => {
                if (!input.validity.valid)
                    isValid = false
            })

        return isValid
    }

    render () {
        Array.from(this.getInputs())
            .filter(input => input.type !== 'hidden')
            .forEach((input) => {
                if ('autocapitalize' in input && input.type !== 'text')
                    input.setAttribute('autocapitalize', 'none')

                if ('autocomplete' in input
                        && !input.getAttribute('autocomplete'))
                    input.setAttribute('autocomplete', input.type)
            })
    }
}
